import * as Dialog from '@radix-ui/react-dialog'; // Primitive core layer
import { Dialog as ThemeDialog } from '@radix-ui/themes'; // Theme layouts
import { useModalStore } from '@/state/useModalStore';
import SingletonModal from '@/components/Sheet/SingletonModal';
import { DynamicMetricFeed } from '../Form/DynamicMetricFeed';
//import DeleteConfirmModal from "./contents/DeleteConfirmModal";

export default function ModalRoot() {
  const { modalType, closeModal } = useModalStore();

  const modalContent = () => {
    switch (modalType) {
      case 'SINGLE_METRIC':
        return <SingletonModal />;
      case 'FULL_ADD':
        return <DynamicMetricFeed />;
    }
  };
  return (
    <Dialog.Root
      open={modalType !== null}
      onOpenChange={(open) => !open && closeModal()}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 animate-fade-in" />

        <ThemeDialog.Content
          maxWidth="450px"
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 animate-content-show"
        >
          {modalContent()}
        </ThemeDialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
